import { render, staticRenderFns } from "./DepartmentsForm.vue?vue&type=template&id=b40d17a0"
import script from "./DepartmentsForm.vue?vue&type=script&lang=js"
export * from "./DepartmentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports